/**
 * JOB web
 */


const front = {
    // 前台相关
    saveUserInfo: "/api/User/edit", // 用户保存基本信息
    // 手机号校验
    checkMobile: "/api/UserMobile/check",
    // 短息验证码
    sendSms: "/api/sms/send",

    // 扫码关注公众号登录：
    createQRcode:"/api/Login/qrcode",
    queryScanCode:"/api/Login/check",// 轮询扫码状态

    getFrontJobList: "/api/Job/list",// 获取招聘列表；
    getJobType: "/api/JobType/list", // 获取岗位类别；



}

export default front;
